import React from 'react'
import Footer from '../../Layout/Footer'
import Header from '../../Layout/Header'
import Sidebar from '../../Layout/Sidebar'
import Preloader from '../../Layout/Preloader';
import Select from 'react-dropdown-select';
import { useEffect, useRef, useState } from 'react'
import { getSupplierList, exportSupplierProjectReport } from '../../../Api/Report'
import { getSupplierReport } from '../../../Api/Project'
import { forceDownloadFile } from "../../../ApiService";

function Supplier_report() {
    useEffect(() => {
        document.title = "Supplier Report - Mindforce"
    },);
    const ddlSupplier = useRef();
    const [lstSuppliers, setSuppliers] = useState([]);
    const [selSupplierID, setSupplierID] = useState('');
    const [supplierReportView, setSupplierReportView] = useState([]);
    const [startDate, setStartTimestamp] = useState();
    const [endDate, setEndTimestamp] = useState();

    useEffect(() => {
        getSuppliers();
    }, []);

    const downloadSupplierProjectReport = async(e, row) => {
        e.preventDefault();
        let payload = {
            "supplierID": selSupplierID,
            "projectDetailID": row?.projectDetailID,
            "startDate": startDate,
            "endDate": endDate
        }
        await exportSupplierProjectReport({payload});
    }

    const setTimestamp = (d, t) => {
        if(t === 'startDate')
        setStartTimestamp(d);
        else if(t === 'endDate')
        setEndTimestamp(d);
    }

    const getSuppliers = async() => {
        let res = await getSupplierList();
        if(res.status === 1){
            let arrSuppliers = []
            res.payload?.map((row) => {
                arrSuppliers.push(
                    {
                        "supplierID": row.supplierID,
                        "supplierName": row.supplierCode + ': ' + row.supplierName,
                    }
                )}
            )
            setSuppliers(arrSuppliers);
        } else
        setSuppliers([]);
    }

    const getDownloadReport = async(e) => {
        e.preventDefault();
        let payload = {
            "supplierID": selSupplierID,
            "startDate": startDate,
            "endDate": endDate,
            "viewType": 'download'
        }
        let resSuplrRpt = await getSupplierReport({payload});
        if(resSuplrRpt.status === 1){
            await forceDownloadFile(resSuplrRpt?.payload?.reportURL);
        } 
    };

    const getViewReport = async(e) => {
        e.preventDefault();
        let payload = {
            "supplierID": selSupplierID,
            "startDate": startDate,
            "endDate": endDate,
            "viewType": 'list'
        }
        let resSuplrRpt = await getSupplierReport({payload});
        if(resSuplrRpt.status === 1){
            setSupplierReportView(resSuplrRpt?.payload);
        } 
    };

    const getClearSelection = (e) => {
        e.preventDefault();
        setSupplierReportView([]);
        setSupplierID('');
        setStartTimestamp('');
        setEndTimestamp('');
    };

    return (
        <div>
            <Header />
            <div id="layout-wrapper">
                <div className="main-content">

                    <div className="page-content">
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <div>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a >Report</a></li>
                                                <li className="breadcrumb-item active">Supplier Report</li>
                                            </ol>
                                        </div>
                                        <h4 className="mb-sm-0">Supplier Report</h4>
                                        </div>
                                        

                                    </div>
                                </div>
                            </div>
                            {/* <!-- end page title --> */}

                            <div className="row">
                                <div className="col-xl-12 col-lg-12">
                                    <div className="card">

                                        {/* <!-- end card header --> */}

                                        <div className="card-body">
                                            <div className="report">
                                                <form >
                                                    <div className="row">
                                                   
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="ForminputState" className="form-label mb-0">Supplier <span className="required_field">*</span></label>
                                                                <Select
                                                                    id="ddlSupplier"
                                                                    className="form-control"
                                                                    options={lstSuppliers}
                                                                    labelField="supplierName"
                                                                    valueField="supplierID"
                                                                    searchBy="supplierName"
                                                                    onChange={(values) => setSupplierID(values[0]?.supplierID)}
                                                                    placeholder="Select Supplier"
                                                                    ref={ddlSupplier}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label htmlFor="Projectdescription" className="form-label mb-0">From <span className="required_field">*</span></label>
                                                                        <input type="date" className="form-control" id="startDate" max={new Date().toISOString().split("T")[0]} onChange={() => setTimestamp(document.getElementById('startDate').value, 'startDate')} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label htmlFor="exampleInputdate" className="form-label mb-0">To <span className="required_field">*</span></label>
                                                                        <input type="date" className="form-control" id="endDate" max={new Date().toISOString().split("T")[0]} onChange={() => setTimestamp(document.getElementById('endDate').value, 'endDate')} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-lg-4">
                                                        <div className="report_btn">
                                                                <button type="submit" className="btn btn-primary" onClick={(e) => getViewReport(e)}>
                                                                    View    
                                                                </button>
                                                                <button type="submit" className="btn btn-primary mx-2" onClick={(e) => getDownloadReport(e)}>
                                                                    Download
                                                                </button>
                                                                <button type="submit" className="btn btn-danger mx-2" onClick={(e) => getClearSelection(e)}>
                                                                    <i className="ri-refresh-line"></i> Reset
                                                                </button>
                                                               
                                                            </div>
                                                        </div>
                                                        {/* <!--end col--> */}
                                                       
                                                     
                                                        {/* <!--end col--> */}
                                                       


                                                       


                                                        {/* <!--end col--> */}
                                                    </div>
                                                    {/* <!--end row--> */}

                                                    <div className='row'>
                                                        {supplierReportView ? (
                                                                <>
                                                                <div className='hScrollDiv'>
                                                                    <table className="table table-striped table-hover  table_client">
                                                                        {
                                                                            supplierReportView?.length > 0 ? (
                                                                                <>
                                                                                    <thead>
                                                                                        <tr className="bg-primary" style={{ color: "white" }}>
                                                                                            <th>S.No.</th>
                                                                                            <th style={{ textAlign:"left" }}>Project Code</th>
                                                                                            <th style={{ textAlign:"left" }}>Project Name</th>
                                                                                            <th style={{ textAlign:"left" }}>Country</th>
                                                                                            <th>Complete</th>
                                                                                            <th>Terminate</th>
                                                                                            <th>OverQuota</th>
                                                                                            <th>QualityTerm</th>
                                                                                            <th>DropOut</th>
                                                                                            {/* <th>Active</th>
                                                                                            <th>Reject</th> */}
                                                                                            <th>DuplicateUser</th>
                                                                                            <th>DuplicateIP</th>
                                                                                            {/* <th>GeoIP</th> */}
                                                                                            <th>DeviceType</th>
                                                                                            <th>BlockedIP</th>
                                                                                            <th>Speeder</th>
                                                                                            {/* <th>Exclude</th> */}
                                                                                            {/* <th>PSStart</th>
                                                                                            <th>PSTerminate</th>
                                                                                            <th>PSOverQuota</th>
                                                                                            <th>PSDropOut</th> */}
                                                                                            <th>SurveyClose</th>
                                                                                            {/* <th>Inactive</th> */}
                                                                                            <th>TrafficDisabled</th>
                                                                                            <th>ProjectCompleteExhausted</th>
                                                                                            <th>ProjectClickExhausted</th>
                                                                                            <th>SupplierCompleteExhausted</th>
                                                                                            <th>SupplierClickExhausted</th>
                                                                                            <th>MultiLinkNotAvailable</th>
                                                                                            <th>IdentifierNotExist(Recontact)</th>
                                                                                            <th>Fraud User</th>
                                                                                            <th>TSRDFailure</th>
                                                                                            <th>Captcha Failure</th>
                                                                                            <th>TestLink</th>
                                                                                            {/* <th>Action</th> */}
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {
                                                                                            supplierReportView?.map((row, i) => {
                                                                                                return (
                                                                                                    <>
                                                                                                        <tr>
                                                                                                            <td scope="row">{i + 1}</td>
                                                                                                            <td style={{ textAlign:"left" }}>{row?.projectCode}</td>
                                                                                                            <td style={{ textAlign:"left" }}>{row?.projectName}</td>
                                                                                                            <td style={{ textAlign:"left" }}>{row?.projectCountry}</td>
                                                                                                            <td>{row?.completes}</td>
                                                                                                            <td>{row?.terminates}</td>
                                                                                                            <td>{row?.overQuota}</td>
                                                                                                            <td>{row?.qualityTerm}</td>
                                                                                                            <td>{row?.dropOut}</td>
                                                                                                            {/* <td>{row?.active}</td>
                                                                                                            <td>{row?.reject}</td> */}
                                                                                                            <td>{row?.duplicateUser}</td>
                                                                                                            <td>{row?.duplicateIP}</td>
                                                                                                            {/* <td>{row?.geoIP}</td> */}
                                                                                                            <td>{row?.deviceType}</td>
                                                                                                            <td>{row?.blockedIP}</td>
                                                                                                            <td>{row?.speeder}</td>
                                                                                                            {/* <td>{row?.exclude}</td> */}
                                                                                                            {/* <td>{row?.psStart}</td>
                                                                                                            <td>{row?.psTerminate}</td>
                                                                                                            <td>{row?.psOverQuota}</td>
                                                                                                            <td>{row?.psDropOut}</td> */}
                                                                                                            <td>{row?.surveyClose}</td>
                                                                                                            {/* <td>{row?.inactive}</td> */}
                                                                                                            <td>{row?.trafficDisabled}</td>
                                                                                                            <td>{row?.projectCompleteExhausted}</td>
                                                                                                            <td>{row?.projectClickExhausted}</td>
                                                                                                            <td>{row?.supplierCompleteExhausted}</td>
                                                                                                            <td>{row?.supplierClickExhausted}</td>
                                                                                                            <td>{row?.multiLinkNotAvailable}</td>
                                                                                                            <td>{row?.identifierNotExist}</td>
                                                                                                            <td>{row?.fraudUser}</td>
                                                                                                            <td>{row?.tsRdFailure}</td>
                                                                                                            <td>{row?.captchaFailure}</td>
                                                                                                            <td>{row?.testLink}</td>
                                                                                                            {/* <td>
                                                                                                                <button type="button" className="btn btn-success btn-sm" onClick={(e) => downloadSupplierProjectReport(e, row)}><i className="ri-download-line"></i></button>
                                                                                                            </td> */}
                                                                                                        </tr>
                                                                                                    </>
                                                                                                );
                                                                                            })
                                                                                        }
                                                                                    </tbody>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                   <tr>
                                                                                        <td colSpan={13}>
                                                                                            <center>No supplier data found</center>
                                                                                        </td>
                                                                                    </tr> 
                                                                                </>
                                                                            )
                                                                        }
                                                                    </table>
                                                                </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Preloader />
                                                                </>
                                                            )
                                                        }
                                                    </div>
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                {/* <!-- end col --> */}









                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Supplier_report